import type {Dewey} from 'services/metadata/types';

export const isDeweyValue = (
  value: Dewey | unknown | undefined,
): value is Dewey => {
  return !!((value as Dewey)?.value && (value as Dewey)?.source);
};
